module.exports = __webpack_public_path__ + "static/media/bg.f86038a6.jpg";